// Campaign Optimization Platform — fixture data layer.
// Shapes mirror the canonical schemas in docs/12-Campaign-Optimization-Platform.md
// so this module can be swapped for /api/v1/cop/* responses without view changes.
// Demo account: Sideshow Collectibles (matches the example payloads in docs 13/14).

export const account = {
	account_id: '2893',
	merchant_name: 'Sideshow Collectibles',
	domain: 'sideshow.com',
	platform: 'Shopify Plus',
	currency: 'USD',
	data_as_of: 'Today 21:00 UTC',
	policy_version: 'v2.1',
};

// ---- Onsite creative templates (sourced from the Upsellify Templates Figma) ----
// Categories and templates mirror the "v2 / Onsite Templates" page so the Builder
// can pick a creative and deep-link straight to the matching frame in Figma.
export const FIGMA_TEMPLATES_FILE = 'https://www.figma.com/design/ueAXuRs3jlggPcYT8x9yw6/Upsellify-Templates';

export function figmaTemplateUrl(nodeId) {
	if (!nodeId) return FIGMA_TEMPLATES_FILE;
	return `${FIGMA_TEMPLATES_FILE}?node-id=${nodeId.replace(':', '-')}`;
}

const onsiteTemplateCategories = [
	{
		code: 'survey',
		name: 'Survey',
		channel: 'onsite',
		solution_family: 'lead_capture',
		templates: [
			{ name: 'ClearChoice-01', node_id: '2742:30' },
			{ name: 'ClearChoice-02', node_id: '2742:78' },
			{ name: 'ClearChoice-03-textonly', node_id: '2742:132' },
			{ name: 'ClearChoice-Mobile-01', node_id: '2742:180' },
			{ name: 'ClearChoice-Mobile-02', node_id: '2742:213' },
			{ name: 'SV-01-P1', node_id: '2742:236' },
			{ name: 'SV-01-P2', node_id: '2742:257' },
			{ name: 'SV-01-P3', node_id: '2742:277' },
		],
	},
	{
		code: 'lead_capture',
		name: 'Lead Capture',
		solution_family: 'lead_capture',
		templates: [
			{ name: 'LC-boostbar', node_id: '2742:296' },
			{ name: 'LC-01-P1', node_id: '2742:313' },
			{ name: 'LC-01-P2', node_id: '2742:333' },
			{ name: 'PH-01-P1', node_id: '2742:368' },
			{ name: 'PH-01-P2', node_id: '2742:353' },
			{ name: 'LC-inpage', node_id: '2742:385' },
			{ name: 'LC-Cart-sidebar-single', node_id: '2742:396' },
			{ name: 'LC-Cart-01', node_id: '2742:568' },
			{ name: 'LC-Cart-02', node_id: '2742:521' },
			{ name: 'LC-Cart-01-mbl', node_id: '2742:442' },
			{ name: 'LC-Cart-02-mbl', node_id: '2742:472' },
			{ name: 'LC-02-mbl', node_id: '2742:504' },
		],
	},
	{
		code: 'recs',
		name: 'Product Recommendations',
		solution_family: 'product_recommendation',
		templates: [
			{ name: 'TT-Products-01', node_id: '2742:957' },
			{ name: 'TT-Products-02', node_id: '2742:1031' },
			{ name: 'TT-Products-03', node_id: '2742:919' },
			{ name: 'TT-Products-04', node_id: '2742:1132' },
			{ name: 'TT-Products-05', node_id: '2742:702' },
			{ name: 'TT-Products-06', node_id: '2742:663' },
			{ name: 'TT-Products-06-progress', node_id: '2742:1169' },
			{ name: 'TT-Products-07', node_id: '2742:993' },
			{ name: 'TT-Products-11', node_id: '2806:56' },
			{ name: 'TT-Products-sidebar-01', node_id: '2742:845' },
			{ name: 'TT-Products-sidebar-02', node_id: '2742:808' },
			{ name: 'TT-Products-sidebar-03', node_id: '2742:883' },
			{ name: 'TT-products-boostbar', node_id: '2742:742' },
			{ name: 'TT-products-boostbar2', node_id: '2742:775' },
			{ name: 'TT-minicart-01', node_id: '2742:1067' },
			{ name: 'TT-products-mbl-01', node_id: '2742:640' },
			{ name: 'TT-products-mbl-02', node_id: '2742:617' },
		],
	},
	{
		code: 'active_cart',
		name: 'Active Cart',
		solution_family: 'targeted_tactic',
		templates: [
			{ name: 'TT-Cart-01-original', node_id: '2742:1362' },
			{ name: 'TT-cart-02', node_id: '2742:1430' },
			{ name: 'TT-cart-03', node_id: '2742:1215' },
			{ name: 'TT-Cart-sidebar-01', node_id: '2742:1248' },
			{ name: 'TT-Cart-sidebar-02', node_id: '2742:1292' },
			{ name: 'TT-Cart-sidebar-single', node_id: '2742:1336' },
			{ name: 'TT-lowstock', node_id: '2742:1405' },
			{ name: 'TT-Cart-mbl', node_id: '2742:1541' },
			{ name: 'TT-cart-mbl', node_id: '2742:1452' },
			{ name: 'TT-lowstock-mbl', node_id: '2742:1520' },
		],
	},
	{
		code: 'basic',
		name: 'Basic / Targeted Tactic',
		solution_family: 'targeted_tactic',
		templates: [
			{ name: 'TT-01', node_id: '2742:1624' },
			{ name: 'TT-basic', node_id: '2742:1610' },
			{ name: 'TT-basic-sidebar', node_id: '2742:1596' },
			{ name: 'TT-emerging-overlay-a', node_id: '2742:1711' },
			{ name: 'TT-emerging-overlay-b', node_id: '2742:1686' },
			{ name: 'TT-emerging-sidebar-a', node_id: '2742:1699' },
			{ name: 'TT-emerging-sidebar-b', node_id: '2742:1672' },
			{ name: 'TT-emerging-mobile-a', node_id: '2742:1661' },
			{ name: 'TT-emerging-mobile-b', node_id: '2742:1649' },
		],
	},
	{
		code: 'other',
		name: 'Other',
		channel: 'onsite',
		solution_family: 'targeted_tactic',
		templates: [
			{ name: 'TT-Social-Proof-01', node_id: '2742:1726' },
			{ name: 'TT-ATC-01', node_id: '2750:9171' },
		],
	},
];

// Email campaign templates (from the "Email Component Sources" frame in the same
// Figma file) — for Email Remarketing / Hound flows.
const emailTemplateCategories = [
	{
		code: 'email_cart',
		name: 'Cart Recovery',
		channel: 'email',
		solution_family: 'email_remarketing',
		templates: [
			{ name: 'Cart Recovery — Hero', node_id: '274:2807' },
			{ name: 'Cart Contents', node_id: '274:2817' },
			{ name: 'Cart + Recommendations', node_id: '274:2844' },
		],
	},
	{
		code: 'email_hero',
		name: 'Hero / Announcement',
		channel: 'email',
		solution_family: 'email_remarketing',
		templates: [
			{ name: 'Hero', node_id: '274:2801' },
			{ name: 'Hero — Center Product', node_id: '274:2875' },
			{ name: 'Hero — Right Product', node_id: '274:2879' },
			{ name: 'Section + Image', node_id: '274:2809' },
		],
	},
	{
		code: 'email_recs',
		name: 'Recommendations',
		channel: 'email',
		solution_family: 'product_recommendation',
		templates: [
			{ name: 'Recommendations (3-up)', node_id: '274:2844' },
			{ name: 'Body + Image', node_id: '274:2887' },
		],
	},
	{
		code: 'email_promo',
		name: 'Promo',
		channel: 'email',
		solution_family: 'email_remarketing',
		templates: [
			{ name: 'Promo Banner', node_id: '274:2907' },
			{ name: 'Body + Image (reversed)', node_id: '274:2895' },
		],
	},
];

export const TEMPLATE_CHANNELS = [
	{ code: 'onsite', name: 'Onsite' },
	{ code: 'email', name: 'Email' },
];

export const templateCategories = [
	...onsiteTemplateCategories.map((c) => ({ channel: 'onsite', ...c })),
	...emailTemplateCategories,
];

export function templateCategoriesByChannel(channel) {
	return templateCategories.filter((c) => c.channel === channel);
}

// Per-category schema: what the Design tab should render and expose for a given
// template type. `kind` drives the live-preview structure, `content` lists the
// relevant creative text fields (in order), and `style` lists the relevant CSS
// groups. Changing the template (category) swaps all three.
export const templateSchemas = {
	// onsite
	survey: { kind: 'survey', content: ['eyeline', 'question', 'options'], style: ['panel', 'headline', 'close'] },
	lead_capture: { kind: 'lead', content: ['eyeline', 'headline', 'subtext', 'inputPlaceholder', 'buttonText', 'coupon'], style: ['panel', 'headline', 'button', 'close'] },
	recs: { kind: 'recs', content: ['headline', 'subtext', 'buttonText'], style: ['panel', 'headline', 'button', 'close'] },
	active_cart: { kind: 'cart', content: ['headline', 'buttonText', 'coupon'], style: ['panel', 'headline', 'button', 'close'] },
	basic: { kind: 'offer', content: ['eyeline', 'headline', 'buttonText', 'coupon', 'imageUrl'], style: ['panel', 'headline', 'button', 'close'] },
	other: { kind: 'offer', content: ['eyeline', 'headline', 'buttonText', 'coupon'], style: ['panel', 'headline', 'button', 'close'] },
	// email (no close icon — emails don't have a dismiss control)
	email_hero: { kind: 'email-hero', content: ['eyeline', 'headline', 'subtext', 'buttonText', 'imageUrl'], style: ['panel', 'headline', 'button'] },
	email_cart: { kind: 'email-cart', content: ['headline', 'subtext', 'buttonText', 'coupon'], style: ['panel', 'headline', 'button'] },
	email_recs: { kind: 'email-recs', content: ['headline', 'buttonText'], style: ['panel', 'headline', 'button'] },
	email_promo: { kind: 'email-promo', content: ['headline', 'subtext', 'buttonText', 'coupon', 'imageUrl'], style: ['panel', 'headline', 'button'] },
};

export const DEFAULT_TEMPLATE_SCHEMA = templateSchemas.basic;

// Recommendation-driven clusters. These are system-managed (re-derived by the
// clustering engine each run) so the UI exposes them read-only — a client edits
// or deletes only the custom groups they author themselves.
const recommendationSegments = [
	{
		segment_id: 'seg-hva',
		segment_name: 'High-Value Abandoners',
		color: '#ec4899',
		audience_size: 4218,
		avg_cart_value: 327,
		conversion_rate: 12.4,
		confidence_score: 0.94,
		trend: [38, 42, 40, 47, 52, 49, 58, 63],
		behavioral_profile: ['High AOV', 'Cart exit', 'Repeat views'],
		funnel_stage: 'active_checkout_abandonment',
		recommended_solution_family: 'targeted_tactic',
		recommended_action: 'Exclusive offer + reassurance at checkout exit',
		status: 'active',
		offer_token: 'COMEBACK15',
		discount_pct: 15,
		projected_reach_mo: 8400,
		projected_engagement: 11.2,
		projected_aov_delta: 4.1,
	},
	{
		segment_id: 'seg-psb',
		segment_name: 'Price-Sensitive Browsers',
		color: '#8b5cf6',
		audience_size: 8912,
		avg_cart_value: 96,
		conversion_rate: 4.2,
		confidence_score: 0.88,
		trend: [54, 50, 52, 49, 47, 50, 44, 41],
		behavioral_profile: ['Coupon seeking', 'Multi-session', 'Low AOV'],
		funnel_stage: 'product_abandonment',
		recommended_solution_family: 'coupon_corrector',
		recommended_action: 'Threshold nudge + value framing, no flat discount',
		status: 'active',
		offer_token: 'PERSONALIZED20',
		discount_pct: 20,
		projected_reach_mo: 16100,
		projected_engagement: 8.7,
		projected_aov_delta: -1.2,
	},
	{
		segment_id: 'seg-loy',
		segment_name: 'Loyalty Cohort',
		color: '#22d3ee',
		audience_size: 3153,
		avg_cart_value: 204,
		conversion_rate: 14.7,
		confidence_score: 0.91,
		trend: [40, 44, 43, 46, 50, 53, 55, 60],
		behavioral_profile: ['Repeat buyer', 'High LTV', 'Email engaged'],
		funnel_stage: 'post_purchase',
		recommended_solution_family: 'email_remarketing',
		recommended_action: 'VIP early access + category expansion',
		status: 'active',
		offer_token: 'VIPACCESS',
		discount_pct: 0,
		projected_reach_mo: 5900,
		projected_engagement: 17.4,
		projected_aov_delta: 6.8,
	},
	{
		segment_id: 'seg-fvl',
		segment_name: 'First-Visit Lurkers',
		color: '#a3e635',
		audience_size: 12090,
		avg_cart_value: 0,
		conversion_rate: 1.1,
		confidence_score: 0.82,
		trend: [30, 34, 31, 36, 35, 39, 41, 44],
		behavioral_profile: ['Deep session', 'No cart', 'Anonymous'],
		funnel_stage: 'bounce',
		recommended_solution_family: 'lead_capture',
		recommended_action: 'Identity capture with educational hook',
		status: 'monitoring',
		offer_token: 'WELCOME10',
		discount_pct: 10,
		projected_reach_mo: 22800,
		projected_engagement: 5.3,
		projected_aov_delta: 0,
	},
	{
		segment_id: 'seg-cch',
		segment_name: 'Cart Champions',
		color: '#f59e0b',
		audience_size: 1840,
		avg_cart_value: 143,
		conversion_rate: 16.1,
		confidence_score: 0.9,
		trend: [60, 58, 61, 63, 60, 66, 64, 69],
		behavioral_profile: ['Fast to cart', 'Mobile-first', 'Pays full price'],
		funnel_stage: 'active_cart_abandonment',
		recommended_solution_family: 'product_recommendation',
		recommended_action: 'In-cart bundle recommendation, no incentive',
		status: 'building',
		offer_token: 'BUNDLEUP',
		discount_pct: 0,
		projected_reach_mo: 3600,
		projected_engagement: 13.9,
		projected_aov_delta: 9.2,
	},
	{
		segment_id: 'seg-ret',
		segment_name: 'Returners',
		color: '#4ade80',
		audience_size: 7003,
		avg_cart_value: 124,
		conversion_rate: 6.5,
		confidence_score: 0.86,
		trend: [44, 46, 45, 48, 46, 49, 51, 50],
		behavioral_profile: ['30d lapsed', 'Known email', 'Replenish cycle'],
		funnel_stage: 'returning_inactive',
		recommended_solution_family: 'email_remarketing',
		recommended_action: 'Win-back replenishment reminder',
		status: 'monitoring',
		offer_token: 'MISSEDYOU',
		discount_pct: 10,
		projected_reach_mo: 12400,
		projected_engagement: 7.6,
		projected_aov_delta: 2.4,
	},
];

export const segments = recommendationSegments.map((segment) => ({
	source: 'recommendation',
	is_system_managed: true,
	is_targetable: true,
	...segment,
}));

// Palette for client-authored groups so they read distinctly from the
// recommendation clusters in tables and the audience picker.
export const CUSTOM_SEGMENT_COLORS = ['#94a3b8', '#f472b6', '#38bdf8', '#fb923c', '#a78bfa', '#2dd4bf'];

// Factory for a custom (manually targeted) group — the same shape the views
// already consume, tagged source: 'custom' and fully editable/deletable. This
// is what lets a client target a group the recommendations never surfaced.
export function makeCustomSegment(input, seq) {
	const audience = Number(input.audience_size) || 0;
	return {
		segment_id: `seg-custom-${seq}`,
		segment_name: input.segment_name,
		color: input.color || CUSTOM_SEGMENT_COLORS[(seq - 1) % CUSTOM_SEGMENT_COLORS.length],
		audience_size: audience,
		avg_cart_value: Number(input.avg_cart_value) || 0,
		conversion_rate: Number(input.conversion_rate) || 0,
		confidence_score: null,
		trend: [0, 0, 0, 0, 0, 0, 0, 0],
		behavioral_profile:
			Array.isArray(input.behavioral_profile) && input.behavioral_profile.length ? input.behavioral_profile : ['Custom group'],
		funnel_stage: input.funnel_stage || 'custom',
		recommended_solution_family: input.recommended_solution_family || 'custom',
		recommended_action: input.recommended_action || 'Manually defined target group',
		status: input.status || 'draft',
		offer_token: input.offer_token || 'CUSTOMOFFER',
		discount_pct: Number(input.discount_pct) || 0,
		projected_reach_mo: audience ? Math.round(audience * 1.8) : 0,
		projected_engagement: Number(input.projected_engagement) || 0,
		projected_aov_delta: Number(input.projected_aov_delta) || 0,
		source: 'custom',
		is_system_managed: false,
		is_targetable: true,
	};
}

export const segmentIntelligence = {
	headline:
		'A high-confidence segment was identified across 43,201 visitors. The portfolio is in a GROWTH phase with a weighted average conversion rate of 8.4%, up 5.8 points vs last run.',
	body:
		'High-Value Abandoners is the strongest opportunity this week: 4,218 visitors carrying an average $327 cart who exit at checkout reassurance moments, not price moments. Loyalty Cohort shows the strongest expansion economics at 14.7% conversion. First-Visit Lurkers is the largest unidentified pool — an identity-capture play before any incentive spend.',
	updated: '12 min ago',
};

// Q2 Checkout Recovery bandit — matches bandit-lab mockup.
export const liveExperiment = {
	experiment_id: 'exp-2241',
	experiment_name: 'Q2 Checkout Recovery',
	experiment_type: 'bandit_test',
	method: 'Thompson Sampling',
	status: 'live',
	day: 14,
	of_days: 21,
	business_question: 'Which recovery offer maximizes revenue per session at checkout exit?',
	outcome: {
		winner: 'Variant C',
		rps_delta: '+$3.12',
		projected_annual: '+$420K',
		confidence: 0.89,
	},
	variants: [
		{
			variant_id: 'var-a',
			variant_name: 'Variant A',
			label: 'Reassurance only',
			conversion_rate: 3.2,
			rpv: 4.12,
			allocation: 14,
			best_probability: 0.03,
			ci: [2.6, 3.9],
			color: '#8b5cf6',
		},
		{
			variant_id: 'var-b',
			variant_name: 'Variant B',
			label: '10% incentive',
			conversion_rate: 4.8,
			rpv: 5.8,
			allocation: 27,
			best_probability: 0.08,
			ci: [4.1, 5.5],
			color: '#22d3ee',
		},
		{
			variant_id: 'var-c',
			variant_name: 'Variant C',
			label: 'Bundle + countdown',
			conversion_rate: 6.4,
			rpv: 7.24,
			allocation: 59,
			best_probability: 0.89,
			ci: [5.7, 7.1],
			color: '#ec4899',
			winner: true,
		},
	],
	// Daily allocation share per variant (A, B, C) — drives the shift chart.
	allocation_series: [
		{ day: 1, a: 33, b: 33, c: 34 },
		{ day: 2, a: 32, b: 34, c: 34 },
		{ day: 3, a: 30, b: 34, c: 36 },
		{ day: 4, a: 29, b: 33, c: 38 },
		{ day: 5, a: 27, b: 33, c: 40 },
		{ day: 6, a: 25, b: 32, c: 43 },
		{ day: 7, a: 24, b: 31, c: 45 },
		{ day: 8, a: 22, b: 31, c: 47 },
		{ day: 9, a: 21, b: 30, c: 49 },
		{ day: 10, a: 19, b: 30, c: 51 },
		{ day: 11, a: 18, b: 29, c: 53 },
		{ day: 12, a: 16, b: 28, c: 56 },
		{ day: 13, a: 15, b: 28, c: 57 },
		{ day: 14, a: 14, b: 27, c: 59 },
	],
};

export const archivedExperiments = [
	{
		experiment_id: 'exp-1908',
		experiment_name: 'Cart Abandonment Retargeting — Q1 Legacy',
		experiment_type: 'lift_test',
		status: 'archived',
		result: '+11.2% conversion lift · 96% confidence',
		concluded: 'Mar 30, 2026',
	},
	{
		experiment_id: 'exp-1857',
		experiment_name: 'Free Shipping Threshold — $85 vs $100',
		experiment_type: 'split_test',
		status: 'archived',
		result: '$85 threshold won · +6.1% AOV · 93% confidence',
		concluded: 'Feb 12, 2026',
	},
];

// Experiment management records for the Experiment Lab CRUD list. The live and
// archived experiments are system-managed mirrors (read-only); custom ones the
// operator authors are fully editable/deletable.
export const seedExperiments = [
	{
		experiment_id: liveExperiment.experiment_id,
		experiment_name: liveExperiment.experiment_name,
		experiment_type: liveExperiment.experiment_type,
		status: 'live',
		primary_metric: 'revenue_per_session',
		target_segment_id: 'seg-hva',
		variants: liveExperiment.variants.map((v) => ({ variant_name: v.variant_name, allocation: v.allocation })),
		source: 'recommendation',
		is_system_managed: true,
	},
	...archivedExperiments.map((a) => ({
		experiment_id: a.experiment_id,
		experiment_name: a.experiment_name,
		experiment_type: a.experiment_type,
		status: 'archived',
		primary_metric: 'conversion_rate',
		target_segment_id: null,
		result: a.result,
		variants: [],
		source: 'recommendation',
		is_system_managed: true,
	})),
];

export const EXPERIMENT_TYPES = ['split_test', 'lift_test', 'bandit_test', 'holdout'];

// How an experiment's traffic allocation is allowed to change over its run.
// Shared by the New/Edit Experiment modal and the global default in Settings.
export const ALLOCATION_MODES = [
	{ value: 'none', label: 'No auto changes', hint: 'Traffic split stays fixed at what you set. Operators adjust allocation manually.' },
	{ value: 'auto', label: 'All auto changes', hint: 'The bandit engine reallocates traffic toward winners continuously, no approval needed.' },
	{ value: 'periodic', label: 'Periodic changes', hint: 'The engine reallocates on a fixed cadence (e.g. daily) rather than continuously.' },
	{ value: 'approval', label: 'Auto change on approval only', hint: 'The engine proposes reallocations; each routes through the Approval Queue before traffic shifts.' },
];

export const DEFAULT_ALLOCATION_MODE = 'approval';
export const DEFAULT_EXPERIMENT_LENGTH_DAYS = 21;
export const DEFAULT_CONFIDENCE_PCT = 95;

export function makeCustomExperiment(input, seq) {
	return {
		experiment_id: `exp-custom-${seq}`,
		experiment_name: input.experiment_name,
		experiment_type: input.experiment_type || 'split_test',
		status: input.status || 'draft',
		primary_metric: input.primary_metric || 'conversion_rate',
		target_segment_id: input.target_segment_id || null,
		allocation_mode: input.allocation_mode || DEFAULT_ALLOCATION_MODE,
		allocation_period_days: Number(input.allocation_period_days) || 7,
		experiment_length_days: Number(input.experiment_length_days) || 21,
		confidence_pct: Number(input.confidence_pct) || 95,
		variants: (input.variants || []).map((v) => ({ variant_name: v.variant_name, allocation: Number(v.allocation) || 0 })),
		source: 'custom',
		is_system_managed: false,
	};
}

export const initialApprovals = [
	{
		approval_request_id: 'apr-3101',
		action_type: 'launch_campaign',
		action_label: 'Launch Campaign',
		risk_level: 'critical',
		agent: 'opportunity_bot',
		model: 'Claude Opus',
		justification: 'Trigger Black Friday retention sequence for churned segment — projected 3.1× ROAS',
		impact_chip: '+$84K projected · 89% confidence',
		approvers: 'Internal: Head of Growth → Client: Sideshow',
		approval_stages: ['internal', 'client'],
		stage: 'internal',
		rollback: true,
		state: 'submitted',
		expanded: false,
		evidence: [
			'Churned segment: 6,120 lapsed purchasers, avg historical AOV $212',
			'Holdout-measured win-back baseline: 4.1% reactivation',
			'Projected 3.1× ROAS net of incentive cost',
			'Risk flag: overlaps Returners win-back if launched same week',
		],
		impact: { projected_uplift: '+$84,000', incremental_revenue: '+$61,300', margin_impact: '-$9,800' },
		linked: ['Campaign: BF Retention Q4', 'Segment: Churned 90d'],
		sla: '2 hr window',
	},
	{
		approval_request_id: 'apr-3098',
		action_type: 'update_offer',
		action_label: 'Increase Discount',
		risk_level: 'high',
		agent: 'experiment_bot',
		model: 'Claude Sonnet',
		justification: 'Raise checkout incentive from 10% to 18% for high-intent cart-abandonment segment',
		impact_chip: '+$31K projected · 76% confidence',
		approvers: 'Internal: Pricing Lead ✓ → Client: Sideshow',
		approval_stages: ['internal', 'client'],
		stage: 'client',
		rollback: true,
		state: 'submitted',
		expanded: true,
		evidence: [
			'Segment: 2,840 cart abandoners, avg cart value $127, abandonment rate 68%',
			'Baseline: 10% discount yields 22% recovery; historical 18% discount yields 38% recovery',
			'Incrementality model: causal forest estimate — $31K net uplift after discount cost absorption',
			'Risk flags: margin compression on SKUs below 22% gross margin threshold',
		],
		impact: { projected_uplift: '+$31,200', incremental_revenue: '+$44,800', margin_impact: '-$13,600' },
		linked: ['Campaign: Cart Recovery Q4', 'Experiment: EXP-2241'],
		sla: '2 hr window',
	},
	{
		approval_request_id: 'apr-3095',
		action_type: 'declare_experiment_winner',
		action_label: 'Declare Test Winner',
		risk_level: 'medium',
		agent: 'experiment_bot',
		model: 'Claude Haiku',
		justification: 'Promote variant B as default; 94% posterior probability of superiority over 14-day run',
		impact_chip: '+$12K projected · 94% confidence',
		approvers: 'Internal: Analytics Lead → Client: Sideshow',
		approval_stages: ['internal', 'client'],
		stage: 'internal',
		rollback: true,
		state: 'submitted',
		expanded: false,
		evidence: [
			'14-day bandit run, 38,400 sessions',
			'Variant B posterior best-probability 94%, guardrails clean',
		],
		impact: { projected_uplift: '+$12,000', incremental_revenue: '+$12,000', margin_impact: '$0' },
		linked: ['Experiment: VIP Welcome Flow'],
		sla: '8 hr window',
	},
	{
		approval_request_id: 'apr-3092',
		action_type: 'update_suppression_rule',
		action_label: 'Modify Suppression Rules',
		risk_level: 'low',
		agent: 'segment_bot',
		model: 'Claude Haiku',
		justification: 'Exclude recent purchasers (≤30 days) from upsell emails to reduce fatigue and unsubscribe rate',
		impact_chip: '-4.2% list size · Protective',
		approvers: 'Internal: CRM Manager (internal-only)',
		approval_stages: ['internal'],
		stage: 'internal',
		rollback: true,
		state: 'submitted',
		expanded: false,
		evidence: ['Unsubscribe rate 2.3× baseline among ≤30d purchasers receiving upsell sends'],
		impact: { projected_uplift: 'n/a', incremental_revenue: 'n/a', margin_impact: '$0' },
		linked: ['Segment: Recent Purchasers'],
		sla: 'Auto-approve eligible',
	},
];

export const approvalStats = {
	approved_today: 28,
	avg_decision_hrs: 4.2,
	auto_approved: 47,
};

export const governancePolicy = {
	account: 'Sideshow Collectibles',
	flow: 'AI proposes → Upsellit reviews & edits → Client approves → Launch',
	tiers: [
		{ tier: 'Low', rule: 'Auto-Approve', tone: 'green' },
		{ tier: 'Medium', rule: 'Internal review', tone: 'blue' },
		{ tier: 'High', rule: 'Internal + Client', tone: 'amber' },
		{ tier: 'Critical', rule: 'Internal + Client', tone: 'red' },
	],
	sla: ['High/Critical: 2 hr window', 'Medium: 8 hr window'],
	sla_note: 'Business-hours clocks (US Pacific, US Eastern, UK). Expired SLAs escalate — never auto-approve.',
	escalation: 'Auto-escalates to Head of Growth if no response within SLA window.',
	client_surface: 'Client approvals happen in Client Reporting. Notifications: daily summary (default) or immediate email per action. PSM notified if a client decision waits 5+ business days.',
	version: 'Policy v2.1 · Last updated Jun 2026',
};

let auditSeq = 100;
export const initialAuditEvents = [
	{
		id: 'aud-097',
		actor_type: 'ai_agent',
		actor: 'Devain',
		action: 'generated a campaign development packet',
		entity: 'Summer Promo',
		entity_type: 'campaign',
		source: 'worker',
		when: '2m ago',
		time: '10:42 AM',
		day: 'today',
	},
	{
		id: 'aud-096',
		actor_type: 'user',
		actor: 'j.smith',
		action: 'approved Launch Campaign',
		entity: 'High-Value Abandoners',
		entity_type: 'approval_request',
		source: 'dashboard',
		reason: 'Meets revenue threshold',
		when: '18m ago',
		time: '10:26 AM',
		day: 'today',
	},
	{
		id: 'aud-095',
		actor_type: 'ai_agent',
		actor: 'experiment_bot',
		action: 'declared Variant C the winner',
		entity: 'Cart Recovery Optimization',
		entity_type: 'experiment',
		source: 'worker',
		diff: { field: 'status', before: 'Running', after: 'Concluded' },
		when: '1h ago',
		time: '09:44 AM',
		day: 'today',
	},
	{
		id: 'aud-094',
		actor_type: 'system',
		actor: 'System',
		action: 'auto-paused Discount',
		entity: 'Social Proof Hero',
		entity_type: 'campaign',
		source: 'worker',
		diff: { field: 'status', before: 'Live', after: 'Paused' },
		when: '2h ago',
		time: '08:35 AM',
		day: 'today',
	},
	{
		id: 'aud-093',
		actor_type: 'user',
		actor: 'r.patel',
		action: 'rejected Expand Discount',
		entity: 'Returning Visitors',
		entity_type: 'recommendation',
		source: 'dashboard',
		reason: 'Budget freeze Q3',
		when: '3h ago',
		time: '07:15 AM',
		day: 'today',
	},
	{
		id: 'aud-092',
		actor_type: 'ai_agent',
		actor: 'segment_bot',
		action: 'updated Segment',
		entity: 'Price-Sensitive Browsers',
		entity_type: 'segment',
		source: 'api',
		diff: { field: 'size', before: '12,400', after: '14,820' },
		when: '4h ago',
		time: '06:22 AM',
		day: 'today',
	},
	{
		id: 'aud-091',
		actor_type: 'integration',
		actor: 'Slack Bot',
		action: 'triggered readiness check on',
		entity: 'Summer Flash Campaign',
		entity_type: 'readiness_check',
		source: 'slack',
		when: 'Yesterday',
		time: '4:02 PM',
		day: 'yesterday',
	},
	{
		id: 'aud-090',
		actor_type: 'ai_agent',
		actor: 'Devain',
		action: 'generated Experiment',
		entity: 'Countdown vs. Social Proof',
		entity_type: 'experiment',
		source: 'worker',
		when: 'Yesterday',
		time: '2:18 PM',
		day: 'yesterday',
	},
	{
		id: 'aud-089',
		actor_type: 'user',
		actor: 'a.torres',
		action: 'exported performance report',
		entity: 'Q2 Campaigns',
		entity_type: 'report',
		source: 'dashboard',
		when: 'Yesterday',
		time: '10:44 AM',
		day: 'yesterday',
	},
];

export function makeAuditEvent(partial) {
	auditSeq += 1;
	return {
		id: `aud-${auditSeq}`,
		source: 'dashboard',
		when: 'Just now',
		time: new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }),
		day: 'today',
		...partial,
	};
}

export const auditSummary = {
	rollbacks: 2,
	avg_response: '4.2 min',
	by_actor: [
		{ label: 'AI Agent', key: 'ai_agent', count: 31, color: '#ec4899' },
		{ label: 'User', key: 'user', count: 12, color: '#4ade80' },
		{ label: 'System', key: 'system', count: 3, color: '#9ca3c5' },
		{ label: 'Integration', key: 'integration', count: 1, color: '#22d3ee' },
	],
};

export const reporting = {
	kpis: [
		{ label: 'Revenue Influenced', value: '$2.4M', trend: [30, 38, 35, 44, 41, 52, 58, 64], tone: 'pink' },
		{ label: 'Conversion Lift', value: '+5.86%', trend: [20, 26, 24, 31, 36, 34, 41, 46], tone: 'green' },
		{ label: 'Open Opportunities', value: '12', trend: [6, 7, 9, 8, 10, 11, 12, 12], tone: 'purple' },
		{ label: 'New Segments', value: '4', trend: [1, 1, 2, 2, 3, 3, 4, 4], tone: 'cyan' },
		{ label: 'Theories to Test', value: '7', trend: [2, 3, 3, 4, 5, 6, 6, 7], tone: 'amber' },
	],
	executive_summary:
		'Personalization is generating $2.4M in influenced revenue across 8 active segments, an 18% improvement quarter over quarter. GA2, High-Value Abandoners and Price-Sensitive Browsers account for 71% of total lift. Checkout Recovery is your highest ROI campaign at 12.4× return. Three high-confidence expansion opportunities have been identified in untapped mid-funnel cohorts. Recommend prioritizing the Loyalty Cohort upsell experiment — early signals show VIP conversion intent.',
	campaigns: [
		{ name: 'Checkout Recovery', family: 'Targeted Tactic', revenue: '$612K', roi: '12.4×', conv: '8.2%', status: 'active' },
		{ name: 'VIP Welcome Flow', family: 'Loyalty Cohort', revenue: '$331K', roi: '9.1×', conv: '14.2%', status: 'active' },
		{ name: 'Discount + Social Proof', family: 'Price-Sensitive', revenue: '$228K', roi: '6.2%', conv: '5.2%', status: 'active' },
		{ name: 'Win-back Offer', family: 'Returners', revenue: '$96K', roi: '4.8×', conv: '4.1%', status: 'underperforming' },
		{ name: 'Exit-Intent Offer', family: 'Cart Champions', revenue: '$144K', roi: '6.2×', conv: '6.3%', status: 'active' },
	],
	funnel: [
		{ stage: 'Visits', value: 412000, pct: 100 },
		{ stage: 'Engaged', value: 188000, pct: 46 },
		{ stage: 'Carts', value: 64200, pct: 16 },
		{ stage: 'Checkout', value: 31800, pct: 8 },
		{ stage: 'Purchase', value: 18900, pct: 4.6 },
	],
	opportunities: [
		{
			title: 'Expand Checkout Recovery to Mobile',
			detail: '64% of checkout abandons are mobile; current campaign is desktop-weighted. Mobile-first variant projected to recover an incremental pool.',
			projected: '+$184K / yr',
			confidence: 0.91,
		},
		{
			title: 'Re-engage Lapsed Loyalty Members',
			detail: '6,200 dormant members with high historical LTV. Targeted re-engagement with personalized win-back projected at 8.4% reactivation.',
			projected: '+$96K / yr',
			confidence: 0.84,
		},
		{
			title: 'Upsell Loyalty Cohort + VIP Tier',
			detail: 'VIP-intent signals detected across the Loyalty Cohort. Early-access tier upsell carries the highest AOV delta in the portfolio.',
			projected: '+$143K / yr',
			confidence: 0.87,
		},
	],
	new_segments: [
		{ name: 'High-Intent Mobile Abandoners', size: 3240, conv: '8.4%', value: '$67K', badge: 'High Value' },
		{ name: 'Subscription Upsell Candidates', size: 1890, conv: '12.1%', value: '$88K', badge: 'High Value' },
		{ name: 'Re-engagement Window Openers', size: 5120, conv: '3.2%', value: '$72K', badge: 'Volume' },
	],
	theories: [
		{
			theory: 'Urgency messaging increases checkout conversion by >6% for price-sensitive cohorts',
			basis: 'Countdown variants outperform in 3 of 4 recent bandits',
		},
		{
			theory: 'Free-shipping threshold reduction lifts AOV for Cart Champions',
			basis: '$85 threshold won Q1 split test on adjacent cohort',
		},
		{
			theory: 'Early-access framing outperforms VIP discount for the Loyalty Cohort',
			basis: 'Zero-discount VIP flow holds 14.2% conversion',
		},
	],
	periodic_reports: [
		{
			cadence: 'Monthly',
			period: 'June 2026 MTD',
			status: 'client-ready',
			summary:
				'Monthly readout focuses on completed and active tests that changed the current recommendation set, opportunity ranking, or confidence labels.',
			tests: [
				{
					tested: 'Mobile checkout recovery copy: urgency headline vs. reassurance headline',
					result: 'Reassurance variant is leading with +6.4% checkout conversion and no AOV guardrail movement.',
					impact:
						'Raised the mobile recovery opportunity score from 81 to 91 and changed the next best action from generic discounting to trust-building copy.',
				},
				{
					tested: 'Cart Champions free-shipping threshold: $85 vs. $95',
					result: '$85 threshold produced +3.8% RPV but compressed average margin by an estimated 1.1 points.',
					impact:
						'Kept the opportunity in monitoring instead of launch-ready and added margin sensitivity to the intelligence caveats.',
				},
				{
					tested: 'VIP Welcome Flow: early access framing vs. 10% discount framing',
					result: 'Early access maintained 14.2% conversion with zero incentive cost; discount variant did not clear lift threshold.',
					impact:
						'Updated reporting guidance to prioritize non-discount loyalty expansion for high-LTV cohorts.',
				},
			],
		},
		{
			cadence: 'Quarterly',
			period: 'Q2 2026',
			status: 'QBR packet',
			summary:
				'Quarterly readout rolls up test outcomes into durable intelligence: which tactics scaled, which assumptions were retired, and where the next planning cycle should focus.',
			tests: [
				{
					tested: 'Checkout Recovery bandit: static incentive vs. social proof vs. trust copy',
					result: 'Trust copy became the default winner across desktop and mobile with +$420K projected annualized revenue.',
					impact:
						'Moved checkout recovery from exploratory to scale recommendation and increased the portfolio lift forecast used in executive reporting.',
				},
				{
					tested: 'Win-back Offer lift test on lapsed purchasers',
					result: 'Measured lift held below the 5% target after excluding the May 28-29 tag outage window.',
					impact:
						'Marked win-back as underperforming, reduced projected impact, and surfaced data-quality caveats directly in the intelligence summary.',
				},
				{
					tested: 'Price-Sensitive Browser targeting: broad coupon audience vs. intent-scored audience',
					result: 'Intent scoring reduced reach by 18% but improved incremental revenue per session by 9.6%.',
					impact:
						'Tightened future segment recommendations around coupon intent and moved broad discounting behind approval review.',
				},
			],
		},
	],
};

export const deepResearch = {
	default_question:
		'If margin pressure worsens next quarter and mobile checkout abandonment keeps rising, which optimization bets should Sideshow prioritize, delay, or retire?',
	source_groups: [
		{ key: 'performance', label: 'Performance data', count: 4 },
		{ key: 'experiments', label: 'Experiments', count: 3 },
		{ key: 'segments', label: 'Segments', count: 3 },
		{ key: 'governance', label: 'Governance', count: 2 },
	],
	sources: [
		{
			id: 'S1',
			group: 'performance',
			title: 'Client Reporting: Campaign Analytics',
			freshness: 'data as of Today 21:00 UTC',
			scope: 'Campaign revenue, conversion, ROI, and funnel loss by device',
			supports: 'Checkout Recovery ROI, mobile abandonment headroom, campaign-level influenced revenue',
		},
		{
			id: 'S2',
			group: 'experiments',
			title: 'Experiment Lab: Checkout Recovery Bandit',
			freshness: 'posterior refresh 12 min ago',
			scope: 'Variant allocation, best probability, guardrail metrics, annualized projection',
			supports: 'Trust-copy winner signal, +$420K projected annual revenue, clean AOV guardrail',
		},
		{
			id: 'S3',
			group: 'segments',
			title: 'Clustering Studio: High-Intent Mobile Abandoners',
			freshness: 'last re-cluster 12 min ago',
			scope: 'Audience size, funnel stage, conversion baseline, confidence, recommended action',
			supports: '3,240 visitor segment, 8.4% conversion, high-value mobile checkout cohort',
		},
		{
			id: 'S4',
			group: 'experiments',
			title: 'Monthly Test Report: Free-Shipping Threshold',
			freshness: 'June 2026 MTD',
			scope: 'Cart Champions threshold test, RPV movement, margin caveat',
			supports: '+3.8% RPV at $85 threshold, estimated 1.1-point margin compression',
		},
		{
			id: 'S5',
			group: 'performance',
			title: 'Measurement Caveats & Timeline',
			freshness: 'reviewed for current report window',
			scope: 'Tag outage, coupon-overwrite sessions, returns settlement notes',
			supports: 'Win-back underperformance caveat and integrity of incremental reporting labels',
		},
		{
			id: 'S6',
			group: 'governance',
			title: 'Approval Policy v2.1',
			freshness: 'Last updated Jun 2026',
			scope: 'Risk tiers, approval stages, SLA, client-review requirements',
			supports: 'Broad discounting and margin-sensitive launches require internal plus client review',
		},
	],
	report: {
		answer:
			'Prioritize mobile checkout recovery and loyalty expansion, delay broad discount expansion until margin guardrails are explicit, and retire the current win-back offer from the growth plan until it clears a clean lift test. The strongest path is to scale trust-building mobile checkout copy first, then use non-discount VIP framing for loyalty cohorts, while keeping free-shipping threshold changes behind finance review.',
		sections: [
			{
				title: 'Priority 1: Scale mobile checkout recovery',
				sources: ['S1', 'S2', 'S3'],
				body:
					'Mobile checkout remains the highest-confidence revenue headroom because current recovery is desktop-weighted while mobile drives most checkout abandonment. The checkout bandit already shows trust copy outperforming heavier incentive framing, which matters under margin pressure: the report can pursue conversion lift without increasing discount cost.',
			},
			{
				title: 'Priority 2: Expand loyalty without discounting',
				sources: ['S1', 'S4'],
				body:
					'VIP and loyalty behavior is still producing strong conversion without incentive cost. This should be packaged as a margin-protective expansion path: early access, tier recognition, and personalized product discovery before any percentage-off offer.',
			},
			{
				title: 'Delay: Free-shipping threshold changes',
				sources: ['S4', 'S6'],
				body:
					'The $85 threshold improves RPV but introduces measurable margin compression. It should stay in monitoring until finance approves a margin floor and the campaign can be scoped to carts where incremental contribution remains positive.',
			},
			{
				title: 'Retire from growth plan: Current win-back offer',
				sources: ['S5'],
				body:
					'Win-back remains useful as a learning candidate, but it should not receive incremental budget or roadmap priority. The measured lift is below target after accounting for the tag outage caveat, so the intelligence layer should classify it as underperforming rather than projected growth.',
			},
		],
		evidence: [
			{ claim: 'Mobile checkout recovery is the best next bet', finding: 'High-confidence mobile segment plus checkout trust-copy winner signal', sources: ['S1', 'S2', 'S3'] },
			{ claim: 'Discount expansion is not the default answer', finding: 'Threshold test improved RPV but compressed margin', sources: ['S4', 'S6'] },
			{ claim: 'Win-back should be de-prioritized', finding: 'Measured lift remains below the 5% target once caveats are applied', sources: ['S5'] },
		],
		next_actions: [
			'Draft a mobile-first Checkout Recovery campaign using reassurance and trust proof, not a higher discount.',
			'Create a loyalty expansion experiment using early-access framing against the current VIP welcome flow.',
			'Move free-shipping threshold changes to a guarded test plan with finance-approved contribution floors.',
			'Keep win-back in the experiment backlog but remove it from next-quarter growth projections.',
		],
		risks: [
			'The mobile opportunity depends on checkout event freshness; stale device-level data should block launch readiness.',
			'Free-shipping can inflate influenced revenue while weakening contribution margin if scoped too broadly.',
			'Win-back conclusions should be restated if a clean post-outage lift test contradicts the current signal.',
		],
	},
};

export const commandCenter = {
	stats: [
		{ label: 'Active Segments', value: '6', pill: '6 clusters', pillTone: 'green', trend: [3, 4, 4, 5, 5, 6, 6, 6] },
		{ label: 'Live Experiments', value: '7', pill: '7 active', pillTone: 'green', trend: [4, 5, 5, 6, 6, 6, 7, 7] },
		{ label: 'Active Campaigns', value: '12', pill: '12', pillTone: 'green', trend: [6, 8, 7, 9, 10, 11, 12, 12] },
		{ label: 'Avg Conversion Lift', value: '+5.86%', pill: '+5.86%', pillTone: 'green', trend: [20, 24, 28, 26, 33, 38, 42, 46] },
		{ label: 'Pending AI Actions', value: '3', pill: '3', pillTone: 'amber', trend: [1, 1, 2, 2, 2, 3, 3, 3] },
	],
	brief:
		'Portfolio is in a GROWTH state. Variant C in Checkout Recovery has reached an 89% best-probability and is ready to declare — projected +$420K annually. RPV +$3.12. Loyalty Cohort remains the highest expansion-economics segment at 14.7% conversion. Three new segment opportunities were detected in browse data and are pending clustering review.',
	brief_chips: ['Review Segment ↗', 'Declare Winner ↗', 'Review Micro-Segments ↗'],
	live_experiments: [
		{ name: 'Checkout Recovery', sub: 'Bandit · Variant C leading', value: '89%', tone: 'green' },
		{ name: 'VIP Welcome Flow', sub: 'Bandit · Variant B leading', value: '94%', tone: 'green' },
		{ name: 'Upsell Recommendation', sub: 'Split test · gathering data', value: '52%', tone: 'amber' },
		{ name: 'Exit-Intent Offer', sub: 'Lift test · day 9 of 30', value: '61%', tone: 'amber' },
	],
	activity: [
		{ time: '09:14 AM', text: 'Segment re-cluster completed: 6 clusters confirmed', tone: 'purple', tag: 'Clustering' },
		{ time: '09:02 AM', text: 'Devain generated dev packet for Summer Promo', tone: 'pink', tag: 'GPT-4o' },
		{ time: '08:47 AM', text: 'Bandit experiment Variant C reached 89% confidence', tone: 'green', tag: 'Bandit Lab' },
		{ time: '08:31 AM', text: 'Micro-segment anomaly detected in browse data', tone: 'amber', tag: 'Clustering' },
		{ time: '08:09 AM', text: 'Campaign Builder draft saved for High-Value Abandoners', tone: 'cyan', tag: 'Builder' },
	],
	health: [
		{ label: 'Decision Engine', value: '99.98% uptime', ok: true },
		{ label: 'p95 Latency', value: '0.08s', ok: true },
		{ label: 'Thompson Sampling', value: 'Converging', ok: true },
		{ label: 'Data Connections', value: '4 of 4 healthy', ok: true },
		{ label: 'Approval Queue', value: 'SLA clear', ok: true },
	],
};

// ---- Internal View fixtures (never rendered in Client View) ----

export const internalOps = {
	connections: [
		{ name: 'Upsellit Reporting API', lag: '4 min', ok: true },
		{ name: 'Shopify Analytics', lag: '42 min', ok: true },
		{ name: 'Salesforce', lag: '2 hr sync', ok: true },
		{ name: 'CSD', lag: 'live', ok: true },
	],
	tokens: '4.2M / 25M monthly budget',
	queue: '3 jobs queued · worker healthy',
	warnings: [
		{ level: 'error', text: 'Coupon validation failing for 2 codes (SIDESHOW20, VIP10) — readiness blocker on 1 draft campaign' },
		{ level: 'warn', text: 'Shopify summaries lagging 42 min — within the 60 min SLO, watch the trend' },
		{ level: 'warn', text: 'Affiliate discrepancy 9% MTD — below the 25% investigation threshold' },
	],
};

export const clusteringDiagnostics = {
	warnings: [
		{ level: 'warn', text: 'First-Visit Lurkers silhouette 0.41 — weakest cluster boundary; review before activation' },
		{ level: 'ok', text: 'Consent-unknown visitors (18%) excluded from all activation-eligible segments' },
		{ level: 'warn', text: 'Micro-segment anomaly in browse data flagged 08:31 — pending segment_bot review' },
	],
};

export const builderInternals = [
	['Pixel status', 'Live · last load 20:00 UTC'],
	['CSD requirements', 'CSD #4821 · confirmed Jun 9'],
	['Conflict check', 'No live campaign targets this segment'],
	['Creative source', 'design_bot packet · skill 14f1225'],
	['Coupon validation', 'COMEBACK15 valid · VIP10 FAILING'],
];

export const experimentDiagnostics = {
	engine: 'Thompson Sampling · posterior refresh hourly · 10% allocation floor',
	warnings: [
		{ level: 'warn', text: 'Variant A best-probability 3% — prune candidate at the day-16 checkpoint' },
		{ level: 'ok', text: 'Sample-ratio mismatch check passed (p = 0.61)' },
		{ level: 'warn', text: 'Mobile allocation skew +6% vs desktop — monitoring, no action yet' },
	],
};

export const measurementCaveats = [
	{ level: 'warn', text: 'Win-back Offer: tag outage May 28–29 depressed measured conversions (Timeline entry t-2841)' },
	{ level: 'warn', text: 'Influenced revenue includes coupon-overwrite sessions (~3%); incremental figures are unaffected' },
	{ level: 'ok', text: 'Returns are not retroactively scrubbed unless requested — Q2 revenue may settle down ~1.8%' },
];

export const engineStatus = [
	{ label: 'Clustering Engine', state: 'Active', tone: 'green' },
	{ label: 'Bandit Engine', state: 'Running', tone: 'green' },
	{ label: 'Data Pipeline', state: 'Synced', tone: 'cyan' },
	{ label: 'Approval Queue', state: 'Open', tone: 'amber' },
];

// ---- Exit Intelligence ----
// Surfaces how the onsite exit-detection engine decides *who* to engage and
// *when* to launch. Descriptions and parameter presets mirror the live onsite
// wizard (usi_wizard) but use plain product language for COP. Aggressiveness is
// a 1–10 dial; each level maps to a set of detection parameters (the higher the
// level, the sooner and more often a launch is allowed). The detection-zone and
// anti-falsing concepts are folded into the parameter they govern.
export const exitIntelligence = {
	engine: 'Predictive Exit · cursor + behavior model',
	stats: [
		{ label: 'Exit-Intent Launches', value: '18,420', pill: '7-day', pillTone: 'green', trend: [12, 14, 13, 16, 17, 18, 18, 19] },
		{ label: 'Sessions Recovered', value: '2,640', pill: '14.3% of launches', pillTone: 'green', trend: [9, 10, 11, 12, 12, 13, 14, 14] },
		{ label: 'Avg Purchase Probability', value: '38%', pill: 'at launch', pillTone: 'amber', trend: [30, 32, 31, 34, 36, 37, 38, 38] },
		{ label: 'Suppressed False Positives', value: '6,910', pill: 'anti-falsing', pillTone: 'green', trend: [4, 5, 5, 6, 6, 7, 7, 7] },
	],
	// Each preset 1–10 controls the desktop exit-detection geometry. Stored as
	// display-ready strings; the higher levels launch sooner and more often.
	aggressivenessPresets: {
		1: { label: 'Very conservative', exitArea: '12 px', contentStart: '200 px', speedUpward: '0.35 s', timeAboveY: '1.50 s', timeHover: '7.50 s', noPopQuadrant: '40%', tabDetection: '3.00 s' },
		2: { label: 'Conservative', exitArea: '14 px', contentStart: '200 px', speedUpward: '0.45 s', timeAboveY: '1.25 s', timeHover: '5.00 s', noPopQuadrant: '33%', tabDetection: '2.50 s' },
		3: { label: 'Conservative', exitArea: '16 px', contentStart: '200 px', speedUpward: '0.55 s', timeAboveY: '1.00 s', timeHover: '3.50 s', noPopQuadrant: '20%', tabDetection: '2.00 s' },
		4: { label: 'Balanced', exitArea: '18 px', contentStart: '175 px', speedUpward: '0.65 s', timeAboveY: '0.75 s', timeHover: '3.00 s', noPopQuadrant: '18%', tabDetection: '1.50 s' },
		5: { label: 'Balanced', exitArea: '20 px', contentStart: '150 px', speedUpward: '0.80 s', timeAboveY: '0.50 s', timeHover: '2.50 s', noPopQuadrant: '15%', tabDetection: '1.00 s' },
		6: { label: 'Eager', exitArea: '22 px', contentStart: '125 px', speedUpward: '0.95 s', timeAboveY: '0.35 s', timeHover: '2.00 s', noPopQuadrant: '12%', tabDetection: '0.75 s' },
		7: { label: 'Eager', exitArea: '24 px', contentStart: '100 px', speedUpward: '1.10 s', timeAboveY: '0.25 s', timeHover: '1.50 s', noPopQuadrant: '10%', tabDetection: '0.50 s' },
		8: { label: 'Aggressive', exitArea: '26 px', contentStart: '75 px', speedUpward: '1.30 s', timeAboveY: '0.15 s', timeHover: '1.00 s', noPopQuadrant: '8%', tabDetection: '0.25 s' },
		9: { label: 'Aggressive', exitArea: '28 px', contentStart: '50 px', speedUpward: '1.50 s', timeAboveY: '0.10 s', timeHover: '0.75 s', noPopQuadrant: '5%', tabDetection: '0.13 s' },
		10: { label: 'Maximum', exitArea: '30 px', contentStart: '0 px', speedUpward: '1.75 s', timeAboveY: '0.00 s', timeHover: '0.50 s', noPopQuadrant: '0%', tabDetection: '0.00 s' },
	},
	// Ordered to match the live wizard. Each parameter carries the detection zone
	// and/or anti-falsing safeguard it governs, so the concepts are explained in
	// line with the value they tune (no separate zones / safeguards lists).
	exitParams: [
		{ key: 'tabDetection', label: 'Tab Detection', zone: 'Anti-falsing · Window Tabbing', assoc: 'Switching tabs commonly looks like an exit. This delay waits before a focus change is treated as a suppressing event rather than abandonment.' },
		{ key: 'contentStart', label: 'Content Start', zone: 'Zone · Behavioral Monitoring', assoc: 'Marks where the monitored content area begins. Movement below it reads as browsing — behavior here is scored for intent or hesitation.' },
		{ key: 'speedUpward', label: 'Speed Upward', zone: 'Zone · Heightened Awareness', assoc: 'How fast the cursor must travel upward to count as intent. A slow, weakening approach is treated as Sloppy Site Navigation and suppressed.' },
		{ key: 'exitArea', label: 'Exit Area', zone: 'Zone · Exit Detection', assoc: 'The top-edge band the cursor must reach to confirm abandonment. Exits from the sides or bottom are read as Multi-Tasking, not leaving.' },
		{ key: 'timeAboveY', label: 'Time Above Boundary', zone: 'Zone · Exit Detection', assoc: 'How long the cursor must stay above the exit boundary before a launch is allowed.' },
		{ key: 'timeHover', label: 'Hover Required', zone: 'Zone · Behavioral Monitoring', assoc: 'Minimum dwell time in the content zone before exit behavior becomes eligible to launch.' },
		{ key: 'noPopQuadrant', label: 'No-Launch Quadrant', zone: 'Zone · Back Button Prediction', assoc: 'A protected corner where movement never launches — sparing reaches for the browser back button and other UI.' },
	],
	// Safeguards that run at every level, independent of the aggressiveness dial.
	alwaysOnSafeguards: [
		{ label: 'Window Resizing', desc: 'Resizing the browser is normal behavior, so launch is suppressed.' },
		{ label: 'Finding the Mouse', desc: 'Shaking the mouse to wake the screen or locate the cursor is filtered out.' },
	],
	purchaseSummary: 'A running estimate of how likely the visitor is to complete a purchase, updated live from behavior and profile signals. Adjust any signal to see how it pulls the estimate.',
	diagnostics: {
		engine: 'usi_js predictive monitor · cursor sampling 60 Hz',
		warnings: [
			{ level: 'ok', text: 'Anti-falsing suppressed 6,910 launches this period (27% of raw triggers) — false-positive guardrails healthy' },
			{ level: 'warn', text: 'Mobile Back Stop scope set to all pages — high coverage may raise frequency; review against caps' },
			{ level: 'ok', text: 'Heatmap capture sampling at 100% — no performance regression detected' },
		],
	},
};

// Purchase-probability scoring model, ported from the live onsite wizard. Each
// feature contributes a logit; the contributions are summed onto a baseline,
// lightly compressed, then squashed to a 0–100% estimate. Kept here (not in the
// view) so the math stays one source of truth.
export const PURCHASE_PROBABILITY_CONFIG = {
	baselineRate: 0.04,
	compression: { threshold: 2.0, factor: 0.6 },
	features: {
		'Traffic Source': { type: 'categorical', values: { direct: 0.24, 'type-in': 0.24, paid: 0.08, social: -0.1, organic: 0.06, email: 0.14, referral: 0.0, other: 0.0 } },
		'Geo location': { type: 'binary_match', match: 'us', matchScore: 0.0, otherScore: -0.04 },
		Device: { type: 'categorical', values: { desktop: 0.0, mobile: -0.08, tablet: -0.02, other: 0.0 } },
		Browser: { type: 'categorical', values: { chrome: -0.06, safari: 0.03, firefox: 0.0, edge: 0.0, other: 0.0 } },
		'Viewed Sale': { type: 'boolean', trueScore: 0.1, falseScore: 0.0 },
		'Page Visits': { type: 'log_numeric', coefficient: 0.15, penalties: [{ gt: 30, add: -0.05 }] },
		'Products Viewed': { type: 'log_numeric', coefficient: 0.1, penalties: [{ gt: 10, add: -0.08 }] },
		Cart: { type: 'cart_subtotal', emptyScore: 0.0, baseNonZeroScore: 0.9, coefficient: 0.18, maxScore: 1.35 },
		'Time on Page': { type: 'thresholds', steps: [{ gt: 10, add: 0.03 }, { gt: 30, add: 0.04 }, { gt: 120, add: 0.05 }, { gt: 600, add: 0.03 }, { gt: 1800, add: -0.2 }, { gt: 3600, add: -0.4 }] },
		'Time on Site': { type: 'thresholds', steps: [{ gt: 30, add: 0.04 }, { gt: 120, add: 0.05 }, { gt: 300, add: 0.06 }, { gt: 1200, add: 0.04 }, { gt: 3600, add: -0.18 }, { gt: 7200, add: -0.35 }] },
		'Previous Visits': { type: 'capped_linear', coefficient: 0.1, max: 5 },
		'Availability Issue': { type: 'boolean', trueScore: -0.3, falseScore: 0.0 },
		'Support Visited': { type: 'boolean', trueScore: -0.18, falseScore: 0.0 },
		'Exit Behavior': { type: 'boolean', trueScore: -0.35, falseScore: 0.0 },
		'Hour Of Day': { type: 'hour_ranges', ranges: [{ min: 0, max: 5, score: -0.16 }, { min: 5, max: 8, score: -0.04 }, { min: 8, max: 12, score: 0.1 }, { min: 12, max: 17, score: 0.14 }, { min: 17, max: 20, score: 0.06 }, { min: 20, max: 24, score: -0.03 }], defaultScore: 0.0 },
		'Day Of Week': { type: 'categorical', values: { monday: 0.02, tuesday: 0.1, wednesday: 0.12, thursday: 0.08, friday: 0.01, saturday: -0.06, sunday: -0.03, other: 0.0 } },
	},
};

// Interactive signals shown on the Exit Intelligence page, each with the control
// that drives it (toggle / slider / select), a default, and a display format.
// `attribute` keys back into PURCHASE_PROBABILITY_CONFIG.features.
export const PURCHASE_SIGNALS = [
	{ attribute: 'Cart', control: 'slider', min: 0, max: 500, step: 1, format: 'money', default: 148 },
	{ attribute: 'Traffic Source', control: 'select', format: 'option', default: 'direct', options: [
		{ value: 'direct', label: 'Direct' }, { value: 'type-in', label: 'Type-in' }, { value: 'organic', label: 'Organic' }, { value: 'paid', label: 'Paid' }, { value: 'email', label: 'Email' }, { value: 'social', label: 'Social' }, { value: 'referral', label: 'Referral' } ] },
	{ attribute: 'Device', control: 'select', format: 'option', default: 'desktop', options: [
		{ value: 'desktop', label: 'Desktop' }, { value: 'mobile', label: 'Mobile' }, { value: 'tablet', label: 'Tablet' } ] },
	{ attribute: 'Browser', control: 'select', format: 'option', default: 'chrome', options: [
		{ value: 'chrome', label: 'Chrome' }, { value: 'safari', label: 'Safari' }, { value: 'firefox', label: 'Firefox' }, { value: 'edge', label: 'Edge' } ] },
	{ attribute: 'Geo location', control: 'select', label: 'Country', format: 'option', default: 'us', options: [
		{ value: 'us', label: 'United States' }, { value: 'other', label: 'Other' } ] },
	{ attribute: 'Viewed Sale', control: 'toggle', format: 'yesno', default: true },
	{ attribute: 'Page Visits', control: 'slider', min: 0, max: 40, step: 1, format: 'int', default: 6 },
	{ attribute: 'Products Viewed', control: 'slider', min: 0, max: 20, step: 1, format: 'int', default: 4 },
	{ attribute: 'Previous Visits', control: 'slider', min: 0, max: 10, step: 1, format: 'int', default: 3 },
	{ attribute: 'Time on Page', control: 'slider', min: 0, max: 1800, step: 5, format: 'seconds', default: 90 },
	{ attribute: 'Time on Site', control: 'slider', min: 0, max: 3600, step: 5, format: 'seconds', default: 210 },
	{ attribute: 'Hour Of Day', control: 'slider', min: 0, max: 23, step: 1, format: 'hour', default: 14 },
	{ attribute: 'Day Of Week', control: 'select', format: 'option', default: 'wednesday', options: [
		{ value: 'monday', label: 'Monday' }, { value: 'tuesday', label: 'Tuesday' }, { value: 'wednesday', label: 'Wednesday' }, { value: 'thursday', label: 'Thursday' }, { value: 'friday', label: 'Friday' }, { value: 'saturday', label: 'Saturday' }, { value: 'sunday', label: 'Sunday' } ] },
	{ attribute: 'Availability Issue', control: 'toggle', format: 'yesno', default: false },
	{ attribute: 'Support Visited', control: 'toggle', format: 'yesno', default: false },
	{ attribute: 'Exit Behavior', control: 'toggle', format: 'detected', default: true },
];

export const DEFAULT_PURCHASE_SIGNALS = PURCHASE_SIGNALS.reduce((acc, sig) => {
	acc[sig.attribute] = sig.default;
	return acc;
}, {});

function purchaseSignalScore(attribute, value) {
	const feature = PURCHASE_PROBABILITY_CONFIG.features[attribute];
	if (!feature) return 0;
	const log1p = (n) => Math.log((Number(n) || 0) + 1);
	const asBoolean = (v) => v === true || ['true', 'yes', '1'].includes(String(v).trim().toLowerCase());
	switch (feature.type) {
		case 'categorical': {
			const key = String(value || '').trim().toLowerCase();
			return Object.prototype.hasOwnProperty.call(feature.values, key) ? feature.values[key] : feature.values.other || 0;
		}
		case 'binary_match':
			return String(value || '').trim().toLowerCase() === String(feature.match).toLowerCase() ? feature.matchScore : feature.otherScore;
		case 'boolean':
			return asBoolean(value) ? feature.trueScore : feature.falseScore;
		case 'log_numeric': {
			const n = parseInt(value, 10) || 0;
			let num = (feature.coefficient || 0) * log1p(n);
			(feature.penalties || []).forEach((rule) => { if (n > rule.gt) num += rule.add; });
			return num;
		}
		case 'capped_linear':
			return (feature.coefficient || 0) * Math.min(parseInt(value, 10) || 0, feature.max);
		case 'thresholds': {
			const n = parseInt(value, 10) || 0;
			return (feature.steps || []).reduce((sum, step) => (n > step.gt ? sum + step.add : sum), 0);
		}
		case 'cart_subtotal': {
			const subtotal = parseFloat(value);
			if (isNaN(subtotal) || subtotal <= 0) return feature.emptyScore || 0;
			return Math.min((feature.baseNonZeroScore || 0) + (feature.coefficient || 0) * Math.log(subtotal + 1), feature.maxScore);
		}
		case 'hour_ranges': {
			const hour = parseInt(value, 10);
			if (isNaN(hour)) return feature.defaultScore || 0;
			const match = (feature.ranges || []).find((r) => hour >= r.min && hour < r.max);
			return match ? match.score : feature.defaultScore || 0;
		}
		default:
			return 0;
	}
}

// Returns { score, rows } for a map of signal values. `score` is 0–100; each row
// carries the directional pull (impact) the signal has on the estimate.
export function computePurchaseProbability(values) {
	const logistic = (x) => 1 / (1 + Math.exp(-x));
	const baseline = Math.max(0.0001, Math.min(0.9999, PURCHASE_PROBABILITY_CONFIG.baselineRate));
	let total = Math.log(baseline / (1 - baseline));

	const rows = PURCHASE_SIGNALS.map((sig) => {
		const score = purchaseSignalScore(sig.attribute, values[sig.attribute]);
		total += score;
		const pct = score * 100;
		return {
			attribute: sig.attribute,
			impact: `${score >= 0 ? '+' : ''}${pct.toFixed(1)}%`,
			tone: score > 0 ? 'green' : score < 0 ? 'red' : 'amber',
		};
	});

	const { threshold, factor } = PURCHASE_PROBABILITY_CONFIG.compression;
	if (total > threshold) total = threshold + (total - threshold) * factor;

	return { score: Math.max(0, Math.min(100, Math.round(logistic(total) * 100))), rows };
}

// ---- Settings ----

// Scheduled reports delivered on a cadence to a recipient list. These mirror
// the report types exposed in Intelligence Reporting; later this is the seam
// to a server-side scheduler row.
export const REPORT_TYPES = [
	{ value: 'executive_summary', label: 'Executive Summary' },
	{ value: 'campaign_performance', label: 'Campaign Performance' },
	{ value: 'experiment_results', label: 'Experiment Results' },
	{ value: 'segment_intelligence', label: 'Segment Intelligence' },
	{ value: 'audit_export', label: 'Audit Export' },
];

export const REPORT_CADENCES = [
	{ value: 'daily', label: 'Daily' },
	{ value: 'weekly', label: 'Weekly (Mon)' },
	{ value: 'monthly', label: 'Monthly (1st)' },
];

export const initialScheduledReports = [
	{ id: 'sr-1', name: 'Weekly Executive Summary', report: 'executive_summary', cadence: 'weekly', recipients: 'growth@sideshow.com', format: 'pdf', enabled: true },
	{ id: 'sr-2', name: 'Daily Campaign Performance', report: 'campaign_performance', cadence: 'daily', recipients: 'ops@upsellit.com', format: 'csv', enabled: true },
	{ id: 'sr-3', name: 'Monthly Experiment Results', report: 'experiment_results', cadence: 'monthly', recipients: 'cro@sideshow.com, growth@sideshow.com', format: 'pdf', enabled: false },
];

// Confidence thresholds the engines must clear before acting/surfacing. Stored
// as fractions (0–1); the UI renders them as percentages.
export const DEFAULT_CONFIDENCE = {
	exitDetection: 0.7,
	segmentDetection: 0.75,
	liftSignificance: 0.95,
	recommendation: 0.6,
	autopilotAction: 0.85,
};

// Metadata that drives the confidence sliders on the Settings page.
export const CONFIDENCE_SETTINGS = [
	{
		key: 'exitDetection',
		label: 'Exit-intent detection',
		hint: 'Minimum confidence before an exit-intent trigger fires.',
		tone: 'pink',
	},
	{
		key: 'segmentDetection',
		label: 'Segment detection',
		hint: 'Minimum confidence to assign a visitor to a detected behavioral segment.',
		tone: 'cyan',
	},
	{
		key: 'liftSignificance',
		label: 'Lift-test significance',
		hint: 'Statistical significance required to call a lift test a winner.',
		tone: 'green',
		min: 0.8,
	},
	{
		key: 'recommendation',
		label: 'Recommendation surfacing',
		hint: 'Minimum confidence for the engine to surface a recommendation to operators.',
		tone: 'purple',
	},
	{
		key: 'autopilotAction',
		label: 'Auto-Pilot action',
		hint: 'Minimum confidence Auto-Pilot needs to execute without manual approval.',
		tone: 'amber',
	},
];

// Client brand guide — the account's brand system. Campaigns inherit these
// colors, type, and voice so every creative stays on-brand. Seeded for the demo
// account (Sideshow Collectibles); later this is the seam to a per-account row.
export const DEFAULT_BRAND_GUIDE = {
	// Identity
	logoUrl: '',
	logoLightUrl: '',
	faviconUrl: '',
	tagline: 'Bring home the extraordinary.',
	brandGuidelinesUrl: '',
	// Colors
	primaryColor: '#0f0f12',
	secondaryColor: '#1f2937',
	accentColor: '#e23b2e',
	backgroundColor: '#0b0b0d',
	textColor: '#ffffff',
	mutedColor: '#9aa3b2',
	linkColor: '#e23b2e',
	buttonTextColor: '#ffffff',
	// Typography
	headingFont: 'Poppins, sans-serif',
	fontFamily: 'Inter, sans-serif',
	baseFontSize: '16px',
	headingWeight: '700',
	headlineSize: '1.75em',
	letterSpacing: '0',
	// Buttons
	buttonRadius: '8px',
	buttonPadding: '0.5em 1.5em',
	buttonStyle: 'solid',
	// Voice
	voice: 'Premium and collector-obsessed. Confident, never pushy — celebrate craftsmanship, exclusivity, and the fandoms our customers love.',
	preferredWords: 'collectible, exclusive, limited edition, authentic, curated',
	avoidWords: 'cheap, discount, generic, knockoff',
	emojiUsage: 'sparingly',
};

// Account-wide suppression policy — guardrails that apply to every campaign
// before per-campaign company_json targeting. Mirrors the suppression fields in
// Campaign Rules but scoped globally. ALL_CAPS-free; recipients/lists are plain.
export const DEFAULT_SUPPRESSIONS = {
	suppressedPages: '/account, /login, /checkout/confirmation',
	suppressCookies: 'usi_converted, usi_optout',
	suppressedCountries: '',
	suppressedStates: '',
	excludedSegments: '',
	trafficSourceExcludes: 'paid_brand',
	frequencyCapDay: 3,
	perSessionCap: 1,
	postConversionCooldownDays: 30,
	postDismissCooldownHrs: 24,
	globalHoldoutPercent: 5,
	suppressLoggedIn: false,
	suppressActiveCheckout: true,
	honorGpc: true,
	quietHoursStart: '',
	quietHoursEnd: '',
};

// Deterministic scatter points per segment for the clustering plot.
export function clusterPoints() {
	const pts = [];
	const centers = {
		'seg-hva': [72, 30],
		'seg-psb': [30, 62],
		'seg-loy': [80, 64],
		'seg-fvl': [18, 26],
		'seg-cch': [55, 48],
		'seg-ret': [44, 78],
	};
	segments.forEach((s) => {
		const [cx, cy] = centers[s.segment_id];
		const n = Math.max(8, Math.round(s.audience_size / 700));
		let seed = s.audience_size;
		const rand = () => {
			seed = (seed * 9301 + 49297) % 233280;
			return seed / 233280;
		};
		for (let i = 0; i < n; i++) {
			const angle = rand() * Math.PI * 2;
			const radius = Math.pow(rand(), 0.6) * 11;
			pts.push({
				x: cx + Math.cos(angle) * radius * 1.4,
				y: cy + Math.sin(angle) * radius,
				r: 1.2 + rand() * 2.2,
				color: s.color,
				segment: s.segment_name,
			});
		}
	});
	return pts;
}
